/**
 * ROLE_CATALOG — the product-invariant role catalog every deployment seeds:
 * `owner`, the app's sole built-in role, carrying the whole permission
 * catalog; and `checkin`, a non-built-in example role carrying only
 * `tickets.checkin.scan`, seeded because the door-phone provisioning path
 * (docs/system-design/plans/seed/README.md "Check-in accounts") depends on a
 * role doc already existing at that id.
 *
 * Neither role varies per deployment — a fork's `owner` carries the same
 * catalog as every other fork's, and the door-phone role needs the same one
 * permission everywhere — so this is code, not per-fork seam data. It lives
 * beside `RoleSchema` and the permission catalog rather than in a tracked
 * JSON file a fork would have to remember to edit identically.
 * `provision-member.ts seed-roles` seeds this catalog directly; no path
 * argument, mirroring `seed-workspace`'s own no-arg shape. A workspace owner
 * may still create further custom roles (`isBuiltIn: false`) from the in-app
 * role editor — those are never seeded here.
 */
import { PERMISSIONS } from "./permissions.ts";
import type { Role } from "./role.entity.ts";

export const ROLE_CATALOG: Record<string, Role> = {
	owner: {
		name: "Owner",
		permissions: [...PERMISSIONS],
		isBuiltIn: true,
	},
	checkin: {
		name: "Check-in",
		permissions: ["tickets.checkin.scan"],
		isBuiltIn: false,
	},
};
